<app-dialog-content [title]="titleStr" [hiddenCloseButton]="hideCloseButton">

    <div data-test-id="tokenExpirationDialogContent" class="container">
        <p data-test-id="text">{{bodyMsg}}</p>
    </div>
    
    <!-- Action Buttons -->
    <ng-container uiDialogActions>
        <button data-test-id="cancelActionButton" mat-flat-button color="primary" class="action-buttons" (click)="cancel()" *ngIf="type=='logout'" i18n="Cancel button label text|Label text for cancel button@@appCancelButtonInTokenPage">
            Cancel
        </button>
        <button data-test-id="logoutActionButton" mat-flat-button color="primary" class="action-buttons" (click)="logout()"  i18n="Logout button label text|Label text for logout button@@appLogoutButtonInTokenPage">
            Logout
        </button>
    </ng-container>
</app-dialog-content>
